<template>
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="teachers && !loading" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
                <v-row v-if="pcOnly">
                    <v-col v-for="teacher in teachers" :key="teacher.id" md="3" lg="3" xl="2">
                        <v-card class="pa-4 bordered">
                            <div class="d-flex flex-column align-center">
                                <v-avatar :size="64" class="bordered mb-2">
                                    <v-img :src="teacher.avatar"></v-img>
                                </v-avatar>
                                <div class="mb-3 text-center">
                                    <div class="medium-text strong-text--text">{{teacher.name}}</div>
                                </div>
                                <div class="w-100">
                                    <v-btn block depressed color="primary" :to="{name: 'teacher', params: {id: teacher.id}}">
                                        ملف المعلم
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>

                    </v-col>
                </v-row>
                <v-list v-else class="py-0">
                    <template v-for="teacher in teachers">
                        <v-list-item :key="teacher.id" class="py-1" :to="{name: 'teacher', params: {id: teacher.id}}" v-ripple="phoneOnly ? {class: 'ripple--color'} : false">
                            <v-list-item-avatar size="56" class="bordered">
                                <v-img :src="teacher.avatar"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="strong-text--text medium-text">{{teacher.name}}</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip label small style="height: 22px;" outlined class="pe-2">
                                        <v-icon left>mdi-play-box-multiple</v-icon>
                                        {{unitFormat(teacher.courses_count, 'دورة', 'دورتين', 'دورات')}}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon class="my-auto ms-2">
                                <v-icon size="20" color="grey">mdi-chevron-left</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider v-if="phoneOnly" inset :key="'divider-' + teacher.id" style="opacity: 0.6"></v-divider>
                    </template>
                </v-list>
                
            </v-container>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Courses",
    components: {
        
    },
    data(){
        return {
            teachers: null,

            loading: false,
            openingExam: false,
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        openingExam(loading){
            this.setLinearLoading(loading);
        }
    },
    methods: {
        ...GlobalMethods,
        getTeachers(){
            if (!this.loading){
                this.loading = true;
                const url = '/teachers';
                this.$store.dispatch('fastGetAction', {url}).then(response=>{
                    this.loading = false;
                    this.teachers = response.data.data;

                }).catch(()=>{
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted(){
        if (this.appData.teachers_page){
            this.getTeachers();
        }else{
            this.$router.push('/not-found');
        }
    },
};
</script>